
import firebase from '../../../firebase'


var db = firebase.firestore();


export const watchForConversationUpdates = (conversationUid, next, onNotificationReponse, getState) => {

  return new Promise((resolve, reject) => {
    var conversationRef = db.collection("conversations").doc(conversationUid)

    var unsubscribe = conversationRef

      .onSnapshot((doc) => {

        var conversation = {
          id: doc.id,
          ...doc.data()
        }

        var {messages} = conversation;
        var {messaginScreen: {videoChatId}, user} = getState()

        if (videoChatId) {

          var videoChat = getVideoChat(messages, videoChatId);

          if (videoChat && videoChat.members) {

            var {members} = videoChat;

            var {otherSessions, mySessionSearch} = splitSessionData(members, user)

            if (otherSessions.length && onNotificationReponse) {

              onNotificationReponse({
                otherSessions: [otherSessions[0]]
              })

            }

          }

        }
        resolve(next({
          type: "conversationUpdate",
          unsubscribe,
          conversation: {
            ...conversation,
            messages: conversation.messages.reverse()
          }
        }))
      });
  });
}



export const getVideoChat = (messages, videoChatId) => {
  var videoChat = messages

    .filter((message) => message.videoChat)

    .filter((message) => message.videoChat.id == videoChatId)

  if (videoChat.length > 0) {

    return videoChat[0].videoChat
  }

}


export const splitSessionData = (members, user) => {

  var otherSessions = members.filter((member) => member.userId != user.uid)

  var mySessionSearch = members.filter((member) => member.userId == user.uid)
  return {
    otherSessions,
    mySessionSearch
  }

}



// WEBPACK FOOTER //
// ./src/Components/Conversations/middleware/conversation-subscriptions.js